module.exports = __webpack_public_path__ + "static/media/elegant.9f0a4038.svg";